import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import fi from "./fi";
import pl from "./pl";
import { FALLBACK, applyLang, detect, store, type Lang } from "./lang";

export { LANGUAGES, isLang, type Lang } from "./lang";

/**
 * One bundle, no lazy loading.
 *
 * Three catalogues of a few hundred keys are tens of kilobytes before gzip -
 * less than one of the icons - and a backend plugin would buy a network round
 * trip on first paint in exchange for nothing. It would also mean the language
 * can fail to arrive, and a page that renders raw dotted keys because a fetch
 * lost a race is worse than a page in the wrong language.
 */
export const resources = {
  en: { translation: en },
  pl: { translation: pl },
  fi: { translation: fi },
};

const initial = detect();

void i18n.use(initReactI18next).init({
  resources,
  lng: initial,
  fallbackLng: FALLBACK,
  // React escapes everything it renders; i18next escaping again turns an
  // apostrophe in a bench name into &#39; on screen.
  interpolation: { escapeValue: false },
  // A missing key renders as its English text, never as `null`, so a gap in a
  // catalogue degrades to a readable page rather than to "null" in a table.
  returnNull: false,
});

applyLang(initial);

/**
 * Switch language, and remember it.
 *
 * The order matters: i18next first, because `changeLanguage` is what makes
 * every subscribed component re-render, and only then the side effects. A
 * failed write to localStorage (private mode) must not stop the page from
 * changing language for this visit.
 */
export function setLanguage(lang: Lang): void {
  void i18n.changeLanguage(lang);
  applyLang(lang);
  store(lang);
}

export default i18n;
